import router from './router'
import store from './store'
import { Message } from 'element-ui'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { getToken ,setToken} from '@/utils/auth'
import eventBus from '@/utils/eventBus.js' 

import { isRelogin } from '@/utils/request'
NProgress.configure({ showSpinner: false })

const whiteList = [
]

router.beforeEach((to, from, next) => {
  NProgress.start()
  if(to.name!='TenderProject')
  eventBus.$emit('clear') //清空top的输入框
  if(to.query.token){
    setToken(to.query.token)
    store.dispatch('setToken',to.query.token).then(res=>{
      store.dispatch('GetInfo').then(res=>{
        const newTo = Object.assign({}, to, {
        query: Object.fromEntries(
            Object.entries(to.query).filter(([key]) => key !== 'token')
          )
        });
        next({ ...newTo, replace: true }) // hack方法 确保addRoutes已完成
      })
    })
  }else if (getToken()) {
    to.meta.title && store.dispatch('settings/setTitle', to.meta.title)
    /* has token*/
    if (to.path === '/login') {
      next({ path: '/' })
      NProgress.done()
    } else {
      if (!store.getters.name) {
        isRelogin.show = true
        // 判断当前用户是否已拉取完user_info信息
        store.dispatch('GetInfo').then(() => {
          isRelogin.show = false
          next({ ...to, replace: true }) // hack方法 确保addRoutes已完成
        }).catch(err => {
            store.dispatch('LogOut').then(() => {
              Message.error(err)
              next({ path: '/' })
            })
          })
      } else {
        next()
      }
    }
  } else {
    next()
    // 没有token
    // if (whiteList.indexOf(to.path) !== -1) {
    //   // 在免登录白名单，直接进入
    //   next()
    // } else {
    //   next(`/login?redirect=${to.fullPath}`) // 否则全部重定向到登录页
    //   NProgress.done()
    // }
  }
})

router.afterEach(() => {

  NProgress.done()
})
